import { getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../../constants';
export const Definition = {
  selector: '[data-test-id="tease-notification"]',
  getNudgeProperties: ({
    element
  }) => {
    const subjectElement = element.querySelector(`[data-test-id="tease-notification-subject"]`);
    const title = isHTMLElement(subjectElement) ? getTranslationOrInnerText(subjectElement) : 'no-subject';
    const bodyElement = element.querySelector(`[data-test-id="tease-notification-body"]`);
    const text = isHTMLElement(bodyElement) ? getTranslationOrInnerText(bodyElement) : 'no-body';
    return {
      type: NudgeTypes.POPUP_NOTIFICATIONS,
      title,
      text
    };
  }
};